@if ({row: columnData | async, adata: additionData | async}; as $) {
  @if ($.adata.is_campaign) {
    <div>
      @if ($.row[$.adata.fetch_key].toLowerCase() == 'active') {
        <p-tag styleClass="p-mr-2 text-xxs font-normal uppercase white-space-nowrap" severity="success">{{ $.row[$.adata.fetch_key] }}</p-tag>
      }
      @if ($.row[$.adata.fetch_key].toLowerCase() == 'inactive') {
        <p-tag styleClass="p-mr-2 surface-600 text-xxs font-normal uppercase white-space-nowrap">{{ $.row[$.adata.fetch_key] }}</p-tag>
      }
      @if ($.row[$.adata.fetch_key].toLowerCase() == 'completed') {
        <p-tag styleClass="p-mr-2 text-xxs font-normal uppercase white-space-nowrap" severity="success">{{ $.row[$.adata.fetch_key] }}</p-tag>
      }
      @if ($.row[$.adata.fetch_key].toLowerCase() == 'stopped') {
        <p-tag styleClass="p-mr-2 text-xxs font-normal uppercase white-space-nowrap" severity="warning">{{ $.row[$.adata.fetch_key] }}</p-tag>
      }
      @if ($.row[$.adata.fetch_key].toLowerCase() == 'void') {
        <p-tag styleClass="p-mr-2 text-xxs font-normal uppercase white-space-nowrap" severity="danger">{{ $.row[$.adata.fetch_key] }}</p-tag>
      }
      @if ($.row[$.adata.fetch_key].toLowerCase() == 'scheduled') {
        <p-tag styleClass="p-mr-2 text-xxs font-normal uppercase white-space-nowrap" severity="info">{{ $.row[$.adata.fetch_key] }}</p-tag>
      }
      @if ($.row[$.adata.fetch_key].toLowerCase() == 'inprogress') {
        <p-tag styleClass="p-mr-2 text-xxs font-normal uppercase white-space-nowrap" severity="warning">{{ $.row[$.adata.fetch_key] }}</p-tag>
      }
      @if ($.row[$.adata.fetch_key].toLowerCase() == 'archived') {
        <p-tag styleClass="p-mr-2 text-xxs font-normal uppercase white-space-nowrap" severity="info">{{ $.row[$.adata.fetch_key] }}</p-tag>
      }
    </div>
  }
  @if (!$.adata.is_campaign) {
    <div>
      @if ($.row[$.adata.fetch_key].toLowerCase() === 'active') {
        <div class="flex align-items-center">
          <div class="flex align-items-center justify-content-center bg-primary border-circle">
            <i class="fa-solid fa-arrows-rotate fa-spin m-2"></i>
          </div>
          <i class="fa-solid fa-pause text-lg text-600 cursor-pointer ml-3"  (click)="executeAction('inactive',$.row)" [class.fa-spinner]="rotateIconInactive.value"></i>
        </div>
      }
      @if ($.row[$.adata.fetch_key].toLowerCase() === 'inactive') {
        <div class="flex align-items-center">
          <div class="flex align-items-center justify-content-center surface-600 text-white border-circle cursor-pointer" (click)="executeAction('active',$.row)">
            <i class="fa-solid fa-arrows-rotate m-2"  [class.fa-spinner]="rotateIconActive.value"></i>
          </div>
          <i class="fa-solid fa-pause text-lg text-primary ml-3"></i>
        </div>
      }
    </div>
  }
}
